import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const SearchBar = ({ initial = "", compact, autoFocus, testId = "site-search" }) => {
  const [q, setQ] = useState(initial);
  const { t, to } = useLang();
  const nav = useNavigate();
  useEffect(() => {
    setQ(initial);
  }, [initial]);
  const go = (v) => v.trim() && nav(`${to("/search")}?q=${encodeURIComponent(v.trim())}`);
  return (
    <div data-testid={testId}>
      <form onSubmit={(e) => { e.preventDefault(); go(q); }} role="search"
        className={`flex items-center gap-2 rounded-full border-2 border-forest/15 bg-white p-1.5 shadow-[0_10px_40px_-15px_rgba(40,75,49,0.35)] transition-colors duration-200 focus-within:border-forest ${compact ? "" : "sm:p-2"}`}>
        <Search className="ml-3 h-5 w-5 shrink-0 text-sage" />
        <input value={q} onChange={(e) => setQ(e.target.value)} autoFocus={autoFocus} aria-label={t("search.label")} placeholder={t("search.placeholder")}
          className="min-w-0 flex-1 bg-transparent px-1 py-2 text-base font-medium text-ink outline-none placeholder:text-moss/70" data-testid={`${testId}-input`} />
        <button type="submit" className="btn-primary shrink-0 !px-5 !py-2.5" data-testid={`${testId}-submit`}>{t("search.button")}</button>
      </form>
    </div>
  );
};

export const SearchBand = () => {
  const { t } = useLang();
  return (
    <section className="container-x relative z-10 mt-8 sm:mt-10" data-testid="home-search">
      <div className="rounded-3xl border border-clay bg-linen/95 p-6 backdrop-blur-xl sm:p-8">
        <p className="eyebrow mb-4">{t("search.label")}</p>
        <SearchBar testId="home-search-bar" />
      </div>
    </section>
  );
};
